import  Link  from 'next/link'
import { Card, Col } from 'react-bootstrap'

const Advisors = () => (
    [
        { image: "../../../images/home/dr-brouse.png", name: <strong>Dr. Richard <br className="d-xl-none d-block" />Brouse</strong>, id: "dr-brouse" },
        { image: "../../../images/home/dr-jamie.png",  name: <strong>Dr. Jamie <br className="d-xl-none d-block" /> McManus M.D.</strong>, id: "dr-mcmanus" },
        { image: "../../../images/home/dr-chaney.png", name: <strong>Dr. Steve <br className="d-xl-none d-block" /> Chaney</strong>, id: "dr-chaney" },
        { image: "../../../images/home/dr-miller.png", name: <strong>Debbie <br className="d-xl-none d-block" /> Miller</strong>, id: "dr-miller" },
        { image: "../../../images/home/dr-wootan.png", name: <strong>Dr. George <br className="d-xl-none d-block" /> Wootan M.D.</strong>, id: "dr-wootan" },
        { image: "../../../images/home/dr-james.png", name: <strong>Dr. James <br className="d-xl-none d-block" /> Scala</strong>, id: "dr-scala" }

    ].map((data, idx) => (
        <>
            <Col key={idx} className="px-0">
                <Card className="border-0 mb-3">
                    <div className="rounded-circle overflow-hidden mx-auto" style={{ width: '75%' }} ><Card.Img variant="top" src={data.image} className="img-fluid"/></div>
                    <Card.Body className="px-2">
                        <Card.Title>{data.name}</Card.Title>
                        <Link href={`/nutritional-advisors#${data.id}`}><a className="text-green"><u>View Bio</u></a></Link>
                    </Card.Body>
                </Card>
            </Col>
            <style jsx global>
                {`
                    .contributors .card-title{
                        font-size: 13px;
                    }

                    .contributors .text-green{
                        font-size: 14px;
                    }
                `}
            </style>
        </>
    ))
);

export default Advisors